import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { NvIconButtonModule } from '../nv-icon-button/nv-icon-button.module';
import { NvIconModule } from '../nv-icon/nv-icon.module';
import { NvAutocompleteActionComponent } from './nv-autocomplete-action/nv-autocomplete-action.component';
import { NvTextboxComponent } from './nv-textbox.component';

@NgModule({
  imports: [
    CommonModule,
    NvIconModule,
    NvIconButtonModule,
    MatAutocompleteModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  declarations: [NvAutocompleteActionComponent, NvTextboxComponent],
  exports: [NvTextboxComponent, NvAutocompleteActionComponent],
})
export class NvTextboxModule {}
